export enum InviteFormFields {
  staff = 'staff',
}

export type InviteFormFieldsValues = {
  [InviteFormFields.staff]: InviteFormFieldsValuesForStaff[];
};

export enum InviteFormFieldsForStaff {
  email = 'email',
  isAdmin = 'isAdmin',
}

export type InviteFormFieldsValuesForStaff = {
  [InviteFormFieldsForStaff.email]: string | null;
  [InviteFormFieldsForStaff.isAdmin]: boolean;
};
